<template>
  <v-list-item class="px-0 py-3 d-flex flex-column">
    <v-list-item-title class="insights-filter-title">{{ $t('insights.filters.projects')}}</v-list-item-title>
    <VfAutoSelect
      :items="projects"
      v-model="selectedProjectsModel"
      nameField="name"
      valueField="id"
      hide-details
      allowSingleDelete
      :placeholder="$t('insights.filters.projectsPlaceholder')"
      class="pb-1 pt-3 insights-filter-input-text full-width"
    />
  </v-list-item>
</template>

<script>
export default {
  name: 'ProjectsFilter',
  props: {
    projects: {
      type: Array,
      required: true,
      default: () => []
    },
    selectedProjects: {
      type: Array
    }
  },
  emits: ['selectedProjectsInput'],
  computed: {
    selectedProjectsModel: {
      get () {
        return this.selectedProjects
      },
      set (value) {
        this.$emit('selectedProjectsInput', value)
      }
    }
  }
}
</script>

<style scoped>
</style>
